import { SendingMediaNames } from 'api/models';

import { IconName } from '../Icon';

export const SendingMediaIcon = {
  [SendingMediaNames.email]: IconName.AT,
  [SendingMediaNames.post]: IconName.SEND,
  [SendingMediaNames.registered_post]: IconName.SEND,
};
